import { render, staticRenderFns } from "./score-board.vue?vue&type=template&id=3117e32f&scoped=true&lang=pug&"
import script from "./score-board.vue?vue&type=script&lang=ts&"
export * from "./score-board.vue?vue&type=script&lang=ts&"
import style0 from "./score-board.vue?vue&type=style&index=0&id=3117e32f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3117e32f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
